import React, { FC, ReactNode } from 'react';
import styles from './TopRightButton.module.scss';
import { NavLink } from 'react-router-dom';

type TopRightLinkProps = {
  children: ReactNode;
  path: string;
};

const TopRightLink: FC<TopRightLinkProps> = ({ children, path }) => {
  return (
    <NavLink to={path} className={styles.navLink}>
      {children}
    </NavLink>
  );
};

export default TopRightLink;
